export const control = (
    styles, state, color, colorToSelectedOption, fontWeight,
    border, fontColor, background, fontSize, borderRadius,
) => {
    let backgroundColor = '#fff';

    if (colorToSelectedOption) {
        backgroundColor = state.hasValue ? colorToSelectedOption : '#fff';
    } else {
        backgroundColor = color;
    }

    return {
        ...styles,
        backgroundColor: background || backgroundColor,
        border: border || 'none',
        borderRadius: borderRadius || '15px',
        boxShadow: 'none',
        color: fontColor,
        display: 'flex',
        fontSize: fontSize || '100%',
        fontWeight,
        letterSpacing: '0.8px',
        minHeight: '33px',
        width: '100%',
        '&:hover': {},
    };
};

export const input = (styles, color, fontWeight, fontColor, fontFamily) => ({
    ...styles,
    color: color === '#fff' ? fontColor : '#fff',
    fontFamily: fontFamily || 'Roboto, sans-serif',
    fontSize: '100%',
    fontWeight,
    marginLeft: '8px',
});

export const placeholder = (styles, state, color, fontWeight, fontColor, fontFamily) => ({
    ...styles,
    color: color === '#fff' ? fontColor : '#fff',
    fontFamily: fontFamily || 'Roboto,sans-serif',
    fontSize: '100%',
    fontWeight,
    marginLeft: '8px',
    letterSpacing: 'normal',

    '&:focus': {
        color: '#fff',
    },

    '@media (max-width: 480px)': {
        marginLeft: '0',
    },
});

export const singleValue = (styles, state, color,
    colorToSelectedOption, fontWeight, fontColor, fontFamily,
    display, justifyContent, margin, opacity) => {
    let singleValueColor = fontColor;

    if (colorToSelectedOption || color !== '#fff') {
        singleValueColor = '#fff';
    }

    return {
        ...styles,
        color: fontColor || singleValueColor,
        display: display || 'block',
        fontFamily: fontFamily || 'Roboto,sans-serif',
        fontSize: '100%',
        fontWeight,
        justifyContent: justifyContent || 'none',
        letterSpacing: 'normal',
        marginLeft: '0',
        width: 'min-content',
        margin,
        opacity,
    };
};
